module.exports = __WEBPACK_EXTERNAL_MODULE_155__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 155
// module chunks = 0 1